export const WEBSOCKET_WATCHDOG_INTERVAL_MS = 10_000;
export const WEBSOCKET_MIN_RECOVERY_INTERVAL_MS = 10_000;
